"use client";

import PlpModals from "@/features/product/components/PlpModals";
import PlpTopBar from "@/features/product/components/PlpTopBar";
import { ProductListingPageStoryblok } from "@/generated/sb/sb-types";
import { createFormattedFilters } from "@/lib/depict/filters";
import { DepictFilter } from "@/lib/depict/types";
import { ISbStoryData } from "@storyblok/react/rsc";
import { useMemo, useState } from "react";
import ProductsSection from "../../../product/components/ProductsSection/ProductsSection";
import { useProducts } from "./ListingContext";

interface ProductListingProps {
  story?: ISbStoryData<ProductListingPageStoryblok>;
  preview: boolean;
}

export const ProductListing = ({ story, preview }: ProductListingProps) => {
  const { total, sorts, filters, appliedFilters } = useProducts();
  const [gridSize, setGridSize] = useState(4);

  const formattedFilters = useMemo(() => {
    return createFormattedFilters(filters as DepictFilter[]);
  }, [filters]);
  return (
    <>
      <PlpTopBar
        productCount={total}
        appliedFilters={appliedFilters}
        filters={formattedFilters}
        gridSize={gridSize}
        setGridSize={setGridSize}
        sorts={sorts}
      />
      <div style={{ position: "relative" }}>
        <PlpModals
          currentAppliedFilters={appliedFilters?.length ?? 0}
          filters={formattedFilters}
          productCount={total}
        />
      </div>
      <ProductsSection story={story} gridSize={gridSize} preview={preview} />
    </>
  );
};
